import { createContext } from 'react'

export const ViewEditableContext = createContext<{
  editable: boolean
  setEditable: (v: boolean) => void
} | null>(null)
